<button
  class="componenttiny-blue gs1-color-link-accessible footer-link"
  [gs1Tooltip]="'footer.unsubscribe.button-tooltip' | translate"
  [gs1TooltipDisabled]="isUserAdmin()"
  [disabled]="!isUserAdmin()"
  (click)="openUnsubscribeWizardDialog()"
>
  {{ 'footer.unsubscribe.button' | translate }}
</button>

<ng-container [formGroup]="unsubscribeForm">
  <ng-template #stepOneTemplate>
    <p class="body-little-dark" [translate]="'footer.unsubscribe.step-one.intro'"></p>
    <p class="body-little-dark" [translate]="'footer.unsubscribe.step-one.fact'"></p>
    <p class="componentbutton-blue gs1-color-ui-8" [translate]="'footer.unsubscribe.step-one.warning'"></p>
    <p class="componentbutton-blue gs1-color-ui-8" [translate]="'footer.unsubscribe.step-one.info'"></p>
    <p class="body-little-dark">
      <span>{{ 'footer.unsubscribe.step-one.invoices-open' | translate }} </span>
      <a class="footer-link" routerLink="/factures">{{ 'footer.unsubscribe.step-one.link' | translate }}</a>
      <span> {{ 'footer.unsubscribe.step-one.invoices-close' | translate }}</span>
    </p>
  </ng-template>

  <ng-template #stepTwoTemplate>
    <h5 [translate]="'footer.unsubscribe.step-two.title-know'"></h5>
    <p class="body-little-dark" [translate]="'footer.unsubscribe.step-two.text-one-know'"></p>
    <p class="body-little-dark" [translate]="'footer.unsubscribe.step-two.text-two-know'"></p>
    <h5 [translate]="'footer.unsubscribe.step-two.title-resub'"></h5>
    <p class="body-little-dark" [translate]="'footer.unsubscribe.step-two.text-one-resub'"></p>
    <p class="body-little-dark" [translate]="'footer.unsubscribe.step-two.text-two-resub'"></p>
    <p class="body-little-dark" [translate]="'footer.unsubscribe.step-two.text-three-resub'"></p>
    <gs1-checkbox #accept class="body-little-dark" [name]="'unsubscribe-consent'" (click)="updateAcceptUnsubscribe(accept.checked())">{{
      'footer.unsubscribe.step-two.checkbox' | translate
    }}</gs1-checkbox>
  </ng-template>

  <ng-template #stepThreeTemplate>
    <h5 [translate]="company().isBadPayer ? 'footer.unsubscribe.step-three.badpayer' : 'footer.unsubscribe.step-three.goodpayer'"></h5>
    <h5 [translate]="'footer.unsubscribe.step-three.sorry'"></h5>
    <gs1-radios [label]="'footer.unsubscribe.step-three.reason' | translate">
      <gs1-radio
        formControlName="reason"
        name="reason-judicial-liquidation"
        [value]="'judicial-liquidation'"
        [label]="'footer.unsubscribe.step-three.judicial-liquidation.title' | translate"
        [gs1Tooltip]="'footer.unsubscribe.step-three.judicial-liquidation.tooltip' | translate"
        [gs1TooltipPosition]="'right'"
      >
      </gs1-radio>
      <gs1-radio
        formControlName="reason"
        name="reason-total-termination"
        [value]="'total-termination'"
        [label]="'footer.unsubscribe.step-three.total-termination.title' | translate"
        [gs1Tooltip]="'footer.unsubscribe.step-three.total-termination.tooltip' | translate"
        [gs1TooltipPosition]="'right'"
      >
      </gs1-radio>
      <gs1-radio
        formControlName="reason"
        name="reason-partial-termination"
        [value]="'partial-termination'"
        [label]="'footer.unsubscribe.step-three.partial-termination.title' | translate"
        [gs1Tooltip]="'footer.unsubscribe.step-three.partial-termination.tooltip' | translate"
        [gs1TooltipPosition]="'right'"
      >
      </gs1-radio>
    </gs1-radios>
    <gs1-phone class="font-500" [label]="'footer.unsubscribe.step-three.phone' | translate" [linear]="true" [name]="'phoneNumber'" formControlName="phoneNumber"></gs1-phone>
  </ng-template>
</ng-container>
